export function setEq(a: Set<unknown>, b: Set<unknown>) {
  if (a.size !== b.size) return false;
  for (const item of a) if (!b.has(item)) return false;
  return true;
}
